const processChunkProgressData = (chunkedState, item, chunkId, chunkUploaded) => {
  chunkedState.updateState(state => {
    state.uploaded[chunkId] = Math.max(chunkUploaded, state.uploaded[chunkId] || 0);
  });
  const state = chunkedState.getState();
  const loadedSum = Object.keys(state.uploaded).reduce((res, id) => res + state.uploaded[id], state.startByte);
  const total = item.file.size;
  return {
    loaded: Math.min(loadedSum, total),
    total
  };
};
export default processChunkProgressData;